import { render, staticRenderFns } from "./reserve-dialog.vue?vue&type=template&id=1edcfc0a&scoped=true&"
import script from "./reserve-dialog.vue?vue&type=script&lang=js&"
export * from "./reserve-dialog.vue?vue&type=script&lang=js&"
import style0 from "./reserve-dialog.vue?vue&type=style&index=0&id=1edcfc0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edcfc0a",
  null
  
)

export default component.exports